import React from "react";
import {LoadingDialog} from "../../../../components/DialogLoading";
import {RenameCategoryDialog} from "../DialogRenameCategory";
import {AddCategoryDialog} from "../DialogAddCategory";
import {MoveCategoryDialog} from "../DialogMoveCategory";
import {PostEditorDialog} from "../DialogPostEditor";
import {uploadFile} from "../../../../utils/uploadFile";
import {CategoryCoverImageDialog} from "../DialogCategoryCoverImage";
import {TwoButtonDialog} from "../../../../designSystem/components/TwoButtonDialog";

export enum CONTENT_MANAGEMENT_MODAL_CONTENT {
  LOADING = 'loading',
  RENAME = 'rename',
  ADD = 'add',
  CONFIRM_DELETE = 'confirmDelete',
  CHANGE_COVER = 'changeCover',
  MOVE = 'move',
  POST = 'post',
  CONFIRM_DELETE_POST = 'confirmPost',
}

export const ContentManagementModalContent= ({
  categories,
  selectedCategory,
  createPost,
  editingPost,
  onDeletePost,
  onConfirmDeletePost,
  onSaveRenameCategory,
  onSaveChangeCoverImage,
  onAddCategory,
  onDeleteCategory,
  onCloseDialog,
  onMoveCategory
}) => ({
  [CONTENT_MANAGEMENT_MODAL_CONTENT.LOADING]: (
    <LoadingDialog label="載入中"/>
  ),
  [CONTENT_MANAGEMENT_MODAL_CONTENT.RENAME]: (
    <RenameCategoryDialog
      initialCategory={selectedCategory}
      onCancel={onCloseDialog}
      onSave={onSaveRenameCategory}
    />
  ),
  [CONTENT_MANAGEMENT_MODAL_CONTENT.ADD]: (
    <AddCategoryDialog
      initialCategory={selectedCategory}
      onCancel={onCloseDialog}
      onAdd={onAddCategory}
    />
  ),
  [CONTENT_MANAGEMENT_MODAL_CONTENT.CONFIRM_DELETE]: (
    <TwoButtonDialog
      type="warning"
      title="確定要刪除此分類嗎？它的所有子分類也都會被刪除! 此動作將無法復原"
      leftLabel="不刪除"
      leftOnClick={onCloseDialog}
      rightLabel="刪除"
      rightOnClick={() => onDeleteCategory(selectedCategory?.id)}
      rightIconName="fa-trash"
      rightColor="warning"
    />
  ),
  [CONTENT_MANAGEMENT_MODAL_CONTENT.CHANGE_COVER]: (
    <CategoryCoverImageDialog
      initialCategory={selectedCategory}
      onSaveChangeCoverImage={onSaveChangeCoverImage}
    />
  ),
  [CONTENT_MANAGEMENT_MODAL_CONTENT.MOVE]: (
    <MoveCategoryDialog
      categories={categories}
      initialCategory={selectedCategory}
      onCancel={onCloseDialog}
      onMove={onMoveCategory}
    />
  ),
  [CONTENT_MANAGEMENT_MODAL_CONTENT.POST]: (
    <PostEditorDialog
      categories={categories}
      uploadFile={uploadFile}
      uploadFolder="postImage"
      post={editingPost}
      onCancel={onCloseDialog}
      onSave={createPost}
      onDelete={onDeletePost}
    />
  ),
  [CONTENT_MANAGEMENT_MODAL_CONTENT.CONFIRM_DELETE_POST]: (
    <TwoButtonDialog
      type="warning"
      title= {`確定要刪除【${editingPost?.title}】嗎？此動作將無法復原`}
      leftLabel="不刪除"
      leftOnClick={onCloseDialog}
      rightLabel="刪除"
      rightOnClick={() => onConfirmDeletePost(editingPost?.id)}
      rightIconName="fa-trash"
      rightColor="warning"
    />
  )
});
